export class AddressApiDtoDelegate {
  static isSourceFromICabbi(source) {
    return source === 'icabbi';
  }

  static isSourceFromGoogle(source) {
    return source === 'google';
  }
}
